var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CheckBoxGroup"},_vm._l((_vm.options),function(option,index){return _c('label',{key:option[_vm.bindKey],staticClass:"CheckBox",class:{checked: _vm.isChecked(option, index), disabled: _vm.isDisabled},on:{"click":function($event){return _vm.toggle(option, index)}}},[_vm._v(_vm._s(_vm.getLabelValue(option)))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }